import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    style: _vm.styles
  }, _vm._l(_vm.count, function (i) {
    return _c('span', {
      key: i,
      staticClass: "v-shape",
      class: _vm.classes
    }, [_vm._v("\n    ‌\n    "), _vm._t("default")], 2);
  }), 0);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-ccd93b38_0", {
    source: ".v-shape[data-v-ccd93b38]{background-color:var(--c-color);color-adjust:exact;-webkit-print-color-adjust:exact;border-radius:var(--g-border-radius-standard);display:inline-block;line-height:1;height:var(--c-height);width:var(--c-width)}.v-shape--circle[data-v-ccd93b38]{border-radius:50%}.v-shape--block[data-v-ccd93b38],.v-shape--block>*[data-v-ccd93b38]{display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-ccd93b38";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };